// // import React from 'react';
// // import './ManagerDashboard.css';

// // const ManagerDashboard = () => {
// //   // Top Stats Data (10 cards - Manager view)
// //   const statsData = [
// //     { id: 'stat-total-enquiries', label: 'TOTAL ENQUIRIES', value: '24', sub: 'all sources' },
// //     { id: 'stat-pending-quotes', label: 'PENDING QUOTES', value: '8', sub: 'awaiting submission' },
// //     { id: 'stat-awaiting-approval', label: 'AWAITING APPROVAL', value: '5', sub: 'manager queue' },
// //     { id: 'stat-approved-quotes', label: 'APPROVED QUOTES', value: '12', sub: 'ready for client' },
// //     { id: 'stat-active-projects', label: 'ACTIVE PROJECTS', value: '7', sub: 'in execution' },
// //     { id: 'stat-po-value', label: 'TOTAL PO VALUE', value: '₹48,20,000', sub: 'won orders' },
// //     { id: 'stat-collected', label: 'COLLECTED', value: '₹22,40,000', sub: 'received' },
// //     { id: 'stat-outstanding', label: 'OUTSTANDING', value: '₹25,80,000', sub: 'pending' },
// //     { id: 'stat-team-members', label: 'TEAM MEMBERS', value: '6', sub: 'active sellers' },
// //     { id: 'stat-avg-deal-size', label: 'AVG DEAL SIZE', value: '₹4.2L', sub: 'last 30 days' },
// //   ];

// //   // Pipeline Stages Data (Team consolidated)
// //   const pipelineStages = ['Sourcing', 'Enquiry', 'Quote', 'Approval', 'PO', 'Execution', 'Payment'];
// //   const pipelineCounts = [12, 24, 15, 12, 8, 7, 5];
// //   const pipelineValues = ['₹28.5L', '₹62.3L', '₹48.2L', '₹42.1L', '₹38L', '₹35.5L', '₹22.4L'];

// //   // Enquiry Status Cards Data (Team aggregated)
// //   const enquiryStatusCards = [
// //     { name: 'Pending Quote', count: 8, value: '₹0', color: 'pending' },
// //     { name: 'Quote Submitted', count: 6, value: '₹14.2L', color: 'submitted' },
// //     { name: 'Approved', count: 12, value: '₹48.2L', color: 'approved' },
// //     { name: 'Rejected', count: 3, value: '₹0', color: 'rejected' },
// //     { name: 'Revision', count: 2, value: '₹4.5L', color: 'revision' },
// //   ];

// //   // Project Status Cards Data (Team aggregated)
// //   const projectStatusCards = [
// //     { name: 'Initiated', count: 3, value: '₹12.4L', color: 'initiated' },
// //     { name: 'In Progress', count: 7, value: '₹35.5L', color: 'progress' },
// //     { name: 'Completed', count: 2, value: '₹8.2L', color: 'completed' },
// //   ];

// //   // Recent Enquiries Data (All team members)
// //   const recentEnquiriesData = [
// //     { id: 'ENQ-M9K2P', client: 'Bharat Electronics', quote: '₹12,50,000', status: 'Approved', clientStatus: 'Accepted', owner: 'Priya (Sr.Exec)' },
// //     { id: 'ENQ-H7J3L', client: 'TechNova Solutions', quote: '₹8,20,000', status: 'Approved', clientStatus: 'Signed', owner: 'Karan (Exec)' },
// //     { id: 'ENQ-59AHL', client: 'Orbit Logistics', quote: '₹3,75,000', status: 'Pending Quote', clientStatus: '—', owner: 'Riya (Trainee)' },
// //     { id: 'ENQ-X8Y9Z', client: 'Aster Medtech', quote: '₹22,00,000', status: 'Awaiting Approval', clientStatus: 'Negotiation', owner: 'Priya (Sr.Exec)' },
// //     { id: 'ENQ-Q2W3E', client: 'Global Mfg Co', quote: '₹6,50,000', status: 'Quote Submitted', clientStatus: 'Under Review', owner: 'Anil (Exec)' },
// //   ];

// //   // Team Performance Data (Manager specific)
// //   const teamPerformanceData = [
// //     { name: 'Priya Sharma', role: 'Senior Exec', enquiries: 12, won: 5, value: '₹28.4L', target: '95%' },
// //     { name: 'Karan Mehta', role: 'Executive', enquiries: 8, won: 3, value: '₹14.2L', target: '82%' },
// //     { name: 'Anil Kumar', role: 'Executive', enquiries: 6, won: 2, value: '₹8.5L', target: '74%' },
// //     { name: 'Riya Nair', role: 'Trainee', enquiries: 4, won: 1, value: '₹3.75L', target: '68%' },
// //     { name: 'Sneha Iyer', role: 'Executive', enquiries: 9, won: 4, value: '₹16.9L', target: '88%' },
// //     { name: 'Vikram Singh', role: 'Senior Exec', enquiries: 11, won: 5, value: '₹27.5L', target: '92%' },
// //   ];

// //   return (
// //     <div className="manager-dashboard-container">
// //       <div className="manager-dashboard-wrapper">


// //         {/* Top Stats Grid - Row 1 (5 cards) */}
// //         <div className="manager-top-stats-grid">
// //           {statsData.slice(0, 5).map((stat) => (
// //             <div key={stat.id} className="manager-top-stat-card">
// //               <div className="manager-top-stat-label">{stat.label}</div>
// //               <div className="manager-top-stat-value">{stat.value}</div>
// //               {stat.sub && <div className="manager-top-stat-sub">{stat.sub}</div>}
// //             </div>
// //           ))}
// //         </div>

// //         {/* Top Stats Grid - Row 2 (5 cards) */}
// //         <div className="manager-top-stats-grid">
// //           {statsData.slice(5, 10).map((stat) => (
// //             <div key={stat.id} className="manager-top-stat-card">
// //               <div className="manager-top-stat-label">{stat.label}</div>
// //               <div className="manager-top-stat-value">{stat.value}</div>
// //               {stat.sub && <div className="manager-top-stat-sub">{stat.sub}</div>}
// //             </div>
// //           ))}
// //         </div>

// //         {/* Pipeline Flow Section */}
// //         <div className="manager-pipeline-area">
// //           <h2 className="manager-section-heading">📈 Pipeline Flow (Team Consolidated)</h2>
// //           <div className="manager-pipeline-track">
// //             {pipelineStages.map((stage, idx) => (
// //               <React.Fragment key={idx}>
// //                 <div className="manager-pipeline-node">
// //                   <div className="manager-pipeline-name">{stage}</div>
// //                   <div className="manager-pipeline-counter">{pipelineCounts[idx]}</div>
// //                   <div className="manager-pipeline-amount">{pipelineValues[idx]}</div>
// //                 </div>
// //                 {idx < pipelineStages.length - 1 && (
// //                   <div className="manager-pipeline-connector">→</div>
// //                 )}
// //               </React.Fragment>
// //             ))}
// //           </div>
// //         </div>

// //         {/* Two Column Layout: Enquiry Status + Project Status */}
// //         <div className="manager-two-column-layout">
// //           {/* Enquiry Status Cards Section */}
// //           <div className="manager-enquiry-status-area">
// //             <h2 className="manager-section-heading">📋 Enquiry Status (Team)</h2>
// //             <div className="manager-status-cards-grid">
// //               {enquiryStatusCards.map((card, idx) => (
// //                 <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
// //                   <div className="manager-status-card-name">{card.name}</div>
// //                   <div className="manager-status-card-count">{card.count}</div>
// //                   <div className="manager-status-card-value">{card.value}</div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>

// //           {/* Project Status Cards Section */}
// //           <div className="manager-project-status-area">
// //             <h2 className="manager-section-heading">🚀 Project Status (Team)</h2>
// //             <div className="manager-status-cards-grid">
// //               {projectStatusCards.map((card, idx) => (
// //                 <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
// //                   <div className="manager-status-card-name">{card.name}</div>
// //                   <div className="manager-status-card-count">{card.count}</div>
// //                   <div className="manager-status-card-value">{card.value}</div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>

// //         {/* Team Performance Table */}
// //         <div className="manager-recent-area">
// //           <div className="manager-recent-header">
// //             <h2 className="manager-section-heading">👥 Team Performance & Targets</h2>
// //             <a href="#" className="manager-view-all-link">Download Report →</a>
// //           </div>
// //           <div className="manager-table-wrapper">
// //             <table className="manager-data-table">
// //               <thead>
// //                 <tr className="manager-table-header-row">
// //                   <th className="manager-table-header">EXECUTIVE</th>
// //                   <th className="manager-table-header">ROLE</th>
// //                   <th className="manager-table-header">ENQUIRIES</th>
// //                   <th className="manager-table-header">WON</th>
// //                   <th className="manager-table-header">VALUE</th>
// //                   <th className="manager-table-header">TARGET</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {teamPerformanceData.map((member, idx) => (
// //                   <tr key={idx} className="manager-table-row">
// //                     <td className="manager-table-cell manager-member-name">{member.name}</td>
// //                     <td className="manager-table-cell">{member.role}</td>
// //                     <td className="manager-table-cell">{member.enquiries}</td>
// //                     <td className="manager-table-cell manager-won-value">{member.won}</td>
// //                     <td className="manager-table-cell">{member.value}</td>
// //                     <td className="manager-table-cell">
// //                       <div className="manager-progress-container">
// //                         <span className="manager-percent">{member.target}</span>
// //                         <div className="manager-progress-bar">
// //                           <div className="manager-progress-fill" style={{ width: member.target }}></div>
// //                         </div>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>

// //         {/* Recent Enquiries Section with View All link */}
// //         <div className="manager-recent-area">
// //           <div className="manager-recent-header">
// //             <h2 className="manager-section-heading">🔄 Recent Enquiries (All Team)</h2>
// //             <a href="#" className="manager-view-all-link">View all →</a>
// //           </div>

// //           <div className="manager-table-wrapper">
// //             <table className="manager-data-table">
// //               <thead>
// //                 <tr className="manager-table-header-row">
// //                   <th className="manager-table-header">ID</th>
// //                   <th className="manager-table-header">CLIENT</th>
// //                   <th className="manager-table-header">QUOTE</th>
// //                   <th className="manager-table-header">STATUS</th>
// //                   <th className="manager-table-header">CLIENT STATUS</th>
// //                   <th className="manager-table-header">OWNER</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {recentEnquiriesData.map((row, idx) => (
// //                   <tr key={idx} className="manager-table-row">
// //                     <td className="manager-table-cell">{row.id}</td>
// //                     <td className="manager-table-cell">{row.client}</td>
// //                     <td className="manager-table-cell">{row.quote}</td>
// //                     <td className="manager-table-cell">
// //                       <span className={`manager-status-badge manager-badge-${row.status.toLowerCase().replace(/\s+/g, '-')}`}>
// //                         {row.status}
// //                       </span>
// //                     </td>
// //                     <td className="manager-table-cell">
// //                       {row.clientStatus !== '—' ? (
// //                         <span className={`manager-client-badge manager-client-${row.clientStatus.toLowerCase()}`}>
// //                           {row.clientStatus}
// //                         </span>
// //                       ) : (
// //                         <span className="manager-client-badge manager-client-empty">—</span>
// //                       )}
// //                     </td>
// //                     <td className="manager-table-cell manager-owner-name">{row.owner}</td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ManagerDashboard;















// import React, { useState, useEffect } from 'react';
// import './ManagerDashboard.css';
// import { getAllEnquiries } from '../../../Servicefile/salesService';

// const ManagerDashboard = () => {
//   // ─── State ──────────────────────────────────────────────────────
//   const [loading, setLoading] = useState(true);
//   const [enquiries, setEnquiries] = useState([]);
//   const [teamPerformance, setTeamPerformance] = useState([]);
//   const [totalPayments, setTotalPayments] = useState(0);

//   // ─── Stats Data (Same as SalesDashboard + 2 extra) ────────────
//   const [stats, setStats] = useState({
//     totalEnquiries: 0,
//     totalBudget: 0,
//     enquiry: { count: 0, budget: 0 },        // PENDING
//     approval: { count: 0, budget: 0 },        // APPROVED
//     quote: { count: 0, budget: 0 },           // PAYMENT_RECEIVED
//     assigned: { count: 0, budget: 0 },        // ASSIGNED
//     completed: { count: 0, budget: 0 },       // CLOSED
//     rejected: { count: 0, budget: 0 },        // REJECTED
//     teamMembers: 0,                           // EXTRA
//     totalLeadsMoney: 0,                       // EXTRA
//   });

//   // ─── Pipeline Stages Data ──────────────────────────────────────
//   const [pipelineData, setPipelineData] = useState({
//     stages: ['Enquiry', 'Approval', 'Quote', 'Assigned', 'Completed', 'Rejected'],
//     counts: [0, 0, 0, 0, 0, 0],
//     values: ['₹0', '₹0', '₹0', '₹0', '₹0', '₹0']
//   });

//   // ─── Enquiry Status Cards ──────────────────────────────────────
//   const [enquiryStatusCards, setEnquiryStatusCards] = useState([
//     { name: 'Enquiry', count: 0, value: '₹0', color: 'pending' },
//     { name: 'Approved', count: 0, value: '₹0', color: 'approved' },
//     { name: 'Quoted', count: 0, value: '₹0', color: 'submitted' },
//     { name: 'Assigned', count: 0, value: '₹0', color: 'assigned' },
//     { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
//   ]);

//   // ─── Project Status Cards ──────────────────────────────────────
//   const [projectStatusCards, setProjectStatusCards] = useState([
//     { name: 'Initiated', count: 0, value: '₹0', color: 'initiated' },
//     { name: 'In Progress', count: 0, value: '₹0', color: 'progress' },
//     { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
//   ]);

//   // ─── Recent Enquiries ──────────────────────────────────────────
//   const [recentEnquiries, setRecentEnquiries] = useState([]);

//   // ─── Format Currency ──────────────────────────────────────────
//   const formatCurrency = (amount) => {
//     if (!amount) return '₹0';
//     return `₹${Number(amount).toLocaleString('en-IN')}`;
//   };

//   // ─── Fetch Enquiries Data ─────────────────────────────────────
//   const fetchEnquiriesData = async () => {
//     try {
//       const data = await getAllEnquiries();
//       setEnquiries(data || []);
//       return data || [];
//     } catch (error) {
//       console.error('Error fetching enquiries:', error);
//       return [];
//     }
//   };

//   // ─── Fetch Team Performance ──────────────────────────────────
//   const fetchTeamPerformance = async () => {
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch("https://backend.maamaas.com/catering/api/admin/team-performance", {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to fetch team performance: ${response.status}`);
//       }

//       const data = await response.json();
//       const teamData = Array.isArray(data) ? data : [];
//       setTeamPerformance(teamData);
//       return teamData;

//     } catch (error) {
//       console.error('Error fetching team performance:', error);
//       return [];
//     }
//   };

//   // ─── Fetch Payments Data ─────────────────────────────────────
//   const fetchPaymentsData = async () => {
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch("https://backend.maamaas.com/catering/api/admin/payments", {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to fetch payments: ${response.status}`);
//       }

//       const data = await response.json();
//       const total = data?.data?.reduce((sum, payment) => sum + (payment.paymentAmount || 0), 0) || 0;
//       setTotalPayments(total);
//       return total;

//     } catch (error) {
//       console.error('Error fetching payments:', error);
//       return 0;
//     }
//   };

//   // ─── Calculate Stats ─────────────────────────────────────────
//   const calculateStats = (data, teamData, paymentsTotal) => {
//     // Helper: Count and sum budget for a specific status
//     const getStatusStats = (status) => {
//       const items = data.filter(e => e.leadStatus === status);
//       const count = items.length;
//       const budget = items.reduce((sum, e) => sum + (e.budget || 0), 0);
//       return { count, budget };
//     };

//     // Calculate each status
//     const enquiry = getStatusStats('PENDING');
//     const approval = getStatusStats('APPROVED');
//     const quote = getStatusStats('PAYMENT_RECEIVED');
//     const assigned = getStatusStats('ASSIGNED');
//     const completed = getStatusStats('CLOSED');
//     const rejected = getStatusStats('REJECTED');

//     // Total enquiries and budget
//     const totalEnquiries = data.length;
//     const totalBudget = data.reduce((sum, e) => sum + (e.budget || 0), 0);

//     // Team members count
//     const uniqueMembers = new Set(teamData.map(item => item.executiveName));
//     const teamMembers = uniqueMembers.size;

//     setStats({
//       totalEnquiries,
//       totalBudget,
//       enquiry,
//       approval,
//       quote,
//       assigned,
//       completed,
//       rejected,
//       teamMembers,        // EXTRA
//       totalLeadsMoney: paymentsTotal, // EXTRA
//     });

//     // Update Pipeline Data
//     setPipelineData({
//       stages: ['Enquiry', 'Approval', 'Quote', 'Assigned', 'Completed', 'Rejected'],
//       counts: [
//         enquiry.count,
//         approval.count,
//         quote.count,
//         assigned.count,
//         completed.count,
//         rejected.count
//       ],
//       values: [
//         formatCurrency(enquiry.budget),
//         formatCurrency(approval.budget),
//         formatCurrency(quote.budget),
//         formatCurrency(assigned.budget),
//         formatCurrency(completed.budget),
//         formatCurrency(rejected.budget)
//       ]
//     });

//     // Update Enquiry Status Cards
//     setEnquiryStatusCards([
//       { name: 'Enquiry', count: enquiry.count, value: formatCurrency(enquiry.budget), color: 'pending' },
//       { name: 'Approved', count: approval.count, value: formatCurrency(approval.budget), color: 'approved' },
//       { name: 'Quoted', count: quote.count, value: formatCurrency(quote.budget), color: 'submitted' },
//       { name: 'Assigned', count: assigned.count, value: formatCurrency(assigned.budget), color: 'assigned' },
//       { name: 'Completed', count: completed.count, value: formatCurrency(completed.budget), color: 'completed' },
//     ]);

//     // Update Project Status Cards
//     const initiated = data.filter(e => e.leadStatus === 'ASSIGNED' || e.leadStatus === 'ACCEPT');
//     const inProgress = data.filter(e => e.leadStatus === 'APPROVED' || e.leadStatus === 'PAYMENT_RECEIVED');
//     const completedProjects = data.filter(e => e.leadStatus === 'CLOSED');

//     setProjectStatusCards([
//       {
//         name: 'Initiated',
//         count: initiated.length,
//         value: formatCurrency(initiated.reduce((sum, e) => sum + (e.budget || 0), 0)),
//         color: 'initiated'
//       },
//       {
//         name: 'In Progress',
//         count: inProgress.length,
//         value: formatCurrency(inProgress.reduce((sum, e) => sum + (e.budget || 0), 0)),
//         color: 'progress'
//       },
//       {
//         name: 'Completed',
//         count: completedProjects.length,
//         value: formatCurrency(completedProjects.reduce((sum, e) => sum + (e.budget || 0), 0)),
//         color: 'completed'
//       },
//     ]);

//     // Update Recent Enquiries
//     const recentData = data
//       .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//       .slice(0, 4)
//       .map(e => ({
//         id: e.enquiryId || e.id || 'N/A',
//         client: e.companyName || e.fullName || 'Unknown',
//         quote: formatCurrency(e.budget || 0),
//         status: e.leadStatus === 'PENDING' ? 'Pending' : 
//                 e.leadStatus === 'APPROVED' ? 'Approved' :
//                 e.leadStatus === 'PAYMENT_RECEIVED' ? 'Quote Submitted' :
//                 e.leadStatus === 'ASSIGNED' ? 'Assigned' :
//                 e.leadStatus === 'CLOSED' ? 'Completed' : 'Rejected',
//         clientStatus: e.leadStatus === 'APPROVED' ? 'Accepted' : 
//                       e.leadStatus === 'PAYMENT_RECEIVED' ? 'Under Review' :
//                       e.leadStatus === 'ASSIGNED' ? 'In Progress' :
//                       e.leadStatus === 'CLOSED' ? 'Delivered' : '—',
//         owner: e.sourceBy || 'N/A'
//       }));

//     setRecentEnquiries(recentData);
//   };

//   // ─── Fetch All Data ──────────────────────────────────────────
//   const fetchAllData = async () => {
//     setLoading(true);
//     try {
//       const [enquiriesData, teamData, paymentsTotal] = await Promise.all([
//         fetchEnquiriesData(),
//         fetchTeamPerformance(),
//         fetchPaymentsData()
//       ]);

//       calculateStats(enquiriesData, teamData, paymentsTotal);

//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ─── Fetch Data on Load ──────────────────────────────────────
//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   // ─── Handle View All ─────────────────────────────────────────
//   const handleViewAll = () => {
//     const event = new CustomEvent('changeTab', { detail: { tabId: 'enquiries' } });
//     window.dispatchEvent(event);
//   };

//   // ─── Render ───────────────────────────────────────────────────
//   if (loading) {
//     return (
//       <div style={loadingStyle}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//         <p>Loading dashboard data...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="manager-dashboard-container">
//       <div className="manager-dashboard-wrapper">
//         {/* Top Stats Grid - 10 Cards (8 same as Sales + 2 extra) */}
//         <div className="manager-top-stats-grid">
//           {/* Same as SalesDashboard */}
//           <div className="manager-top-stat-card manager-stat-total">
//             <div className="manager-top-stat-label">TOTAL LEADS</div>
//             <div className="manager-top-stat-value">{stats.totalEnquiries}</div>
//             <div className="manager-top-stat-sub">Total count</div>
//           </div>

//           <div className="manager-top-stat-card">
//             <div className="manager-top-stat-label">ENQUIRY</div>
//             <div className="manager-top-stat-value">{stats.enquiry.count}</div>
//             <div className="manager-top-stat-sub">{formatCurrency(stats.enquiry.budget)}</div>
//           </div>

//           <div className="manager-top-stat-card">
//             <div className="manager-top-stat-label">APPROVAL</div>
//             <div className="manager-top-stat-value">{stats.approval.count}</div>
//             <div className="manager-top-stat-sub">{formatCurrency(stats.approval.budget)}</div>
//           </div>

//           <div className="manager-top-stat-card">
//             <div className="manager-top-stat-label">QUOTE</div>
//             <div className="manager-top-stat-value">{stats.quote.count}</div>
//             <div className="manager-top-stat-sub">{formatCurrency(stats.quote.budget)}</div>
//           </div>

//           <div className="manager-top-stat-card">
//             <div className="manager-top-stat-label">ASSIGNED</div>
//             <div className="manager-top-stat-value">{stats.assigned.count}</div>
//             <div className="manager-top-stat-sub">{formatCurrency(stats.assigned.budget)}</div>
//           </div>

//           <div className="manager-top-stat-card">
//             <div className="manager-top-stat-label">COMPLETED</div>
//             <div className="manager-top-stat-value">{stats.completed.count}</div>
//             <div className="manager-top-stat-sub">{formatCurrency(stats.completed.budget)}</div>
//           </div>

//           <div className="manager-top-stat-card">
//             <div className="manager-top-stat-label">REJECTED</div>
//             <div className="manager-top-stat-value">{stats.rejected.count}</div>
//             <div className="manager-top-stat-sub">{formatCurrency(stats.rejected.budget)}</div>
//           </div>

//           <div className="manager-top-stat-card manager-stat-total">
//             <div className="manager-top-stat-label">TOTAL BUDGET</div>
//             <div className="manager-top-stat-value">{formatCurrency(stats.totalBudget)}</div>
//             <div className="manager-top-stat-sub">All enquiries</div>
//           </div>

//           {/* EXTRA: Team Members */}
//           <div className="manager-top-stat-card manager-stat-team">
//             <div className="manager-top-stat-label">TEAM MEMBERS</div>
//             <div className="manager-top-stat-value">{stats.teamMembers}</div>
//             <div className="manager-top-stat-sub">Active sellers</div>
//           </div>

//           {/* EXTRA: Total Leads Money */}
//           <div className="manager-top-stat-card manager-stat-money">
//             <div className="manager-top-stat-label">TOTAL LEADS MONEY</div>
//             <div className="manager-top-stat-value">{formatCurrency(stats.totalLeadsMoney)}</div>
//             <div className="manager-top-stat-sub">From all leads</div>
//           </div>
//         </div>

//         {/* Pipeline Flow Section */}
//         <div className="manager-pipeline-area">
//           <h2 className="manager-section-heading">Pipeline Flow</h2>
//           <div className="manager-pipeline-track">
//             {pipelineData.stages.map((stage, idx) => (
//               <React.Fragment key={idx}>
//                 <div className="manager-pipeline-node">
//                   <div className="manager-pipeline-name">{stage}</div>
//                   <div className="manager-pipeline-counter">{pipelineData.counts[idx]}</div>
//                   <div className="manager-pipeline-amount">{pipelineData.values[idx]}</div>
//                 </div>
//                 {idx < pipelineData.stages.length - 1 && (
//                   <div className="manager-pipeline-connector">→</div>
//                 )}
//               </React.Fragment>
//             ))}
//           </div>
//         </div>

//         {/* Two Column Layout: Enquiry Status + Project Status */}
//         <div className="manager-two-column-layout">
//           {/* Enquiry Status Cards Section */}
//           <div className="manager-enquiry-status-area">
//             <h2 className="manager-section-heading">Enquiry status</h2>
//             <div className="manager-status-cards-grid">
//               {enquiryStatusCards.map((card, idx) => (
//                 <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
//                   <div className="manager-status-card-name">{card.name}</div>
//                   <div className="manager-status-card-count">{card.count}</div>
//                   <div className="manager-status-card-value">{card.value}</div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Project Status Cards Section */}
//           <div className="manager-project-status-area">
//             <h2 className="manager-section-heading">Project status</h2>
//             <div className="manager-status-cards-grid">
//               {projectStatusCards.map((card, idx) => (
//                 <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
//                   <div className="manager-status-card-name">{card.name}</div>
//                   <div className="manager-status-card-count">{card.count}</div>
//                   <div className="manager-status-card-value">{card.value}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Team Performance Table - Only in ManagerDashboard */}
//         {teamPerformance.length > 0 && (
//           <div className="manager-recent-area">
//             <div className="manager-recent-header">
//               <h2 className="manager-section-heading">Team Performance & Targets</h2>
//               <a href="#" className="manager-view-all-link">Download Report →</a>
//             </div>
//             <div className="manager-table-wrapper">
//               <table className="manager-data-table">
//                 <thead>
//                   <tr className="manager-table-header-row">
//                     <th className="manager-table-header">EXECUTIVE</th>
//                     <th className="manager-table-header">SOURCE</th>
//                     <th className="manager-table-header">ROLE</th>
//                     <th className="manager-table-header">ENQUIRIES</th>
//                     <th className="manager-table-header">WON</th>
//                     <th className="manager-table-header">VALUE</th>
//                     <th className="manager-table-header">TARGET</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {teamPerformance.map((member, idx) => (
//                     <tr key={idx} className="manager-table-row">
//                       <td className="manager-table-cell manager-member-name">{member.executiveName || '-'}</td>
//                       <td className="manager-table-cell">
//                         <span className={`manager-source-badge manager-badge-${member.source?.toLowerCase()}`}>
//                           {member.source || '-'}
//                         </span>
//                       </td>
//                       <td className="manager-table-cell">{member.role || '-'}</td>
//                       <td className="manager-table-cell">{member.enquiries || 0}</td>
//                       <td className="manager-table-cell manager-won-value">{member.won || 0}</td>
//                       <td className="manager-table-cell">{formatCurrency(member.value || 0)}</td>
//                       <td className="manager-table-cell">
//                         <div className="manager-progress-container">
//                           <span className="manager-percent">{member.target || 0}%</span>
//                           <div className="manager-progress-bar">
//                             <div 
//                               className="manager-progress-fill" 
//                               style={{ 
//                                 width: `${Math.min(member.target || 0, 100)}%`,
//                                 background: member.target >= 80 ? '#10B981' : member.target >= 50 ? '#F59E0B' : '#EF4444'
//                               }}
//                             ></div>
//                           </div>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {/* Recent Enquiries Section */}
//         <div className="manager-recent-area">
//           <div className="manager-recent-header">
//             <h2 className="manager-section-heading">Recent enquiries</h2>
//             <a
//               href="#"
//               className="manager-view-all-link"
//               onClick={(e) => {
//                 e.preventDefault();
//                 handleViewAll();
//               }}
//             >
//               View all →
//             </a>
//           </div>

//           <div className="manager-table-wrapper">
//             <table className="manager-data-table">
//               <thead>
//                 <tr className="manager-table-header-row">
//                   <th className="manager-table-header">ID</th>
//                   <th className="manager-table-header">CLIENT</th>
//                   <th className="manager-table-header">QUOTE</th>
//                   <th className="manager-table-header">STATUS</th>
//                   <th className="manager-table-header">CLIENT STATUS</th>
//                   <th className="manager-table-header">OWNER</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {recentEnquiries.length > 0 ? (
//                   recentEnquiries.map((row, idx) => (
//                     <tr key={idx} className="manager-table-row">
//                       <td className="manager-table-cell">{row.id}</td>
//                       <td className="manager-table-cell">{row.client}</td>
//                       <td className="manager-table-cell">{row.quote}</td>
//                       <td className="manager-table-cell">
//                         <span className={`manager-status-badge manager-badge-${row.status.toLowerCase().replace(/\s+/g, '-')}`}>
//                           {row.status}
//                         </span>
//                       </td>
//                       <td className="manager-table-cell">
//                         {row.clientStatus !== '—' ? (
//                           <span className={`manager-client-badge manager-client-${row.clientStatus.toLowerCase()}`}>
//                             {row.clientStatus}
//                           </span>
//                         ) : (
//                           <span className="manager-client-badge manager-client-empty">—</span>
//                         )}
//                       </td>
//                       <td className="manager-table-cell">{row.owner}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#9CA3AF' }}>
//                       No recent enquiries
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         .spinner-border {
//           display: inline-block;
//           width: 2rem;
//           height: 2rem;
//           border: 0.25em solid currentColor;
//           border-right-color: transparent;
//           border-radius: 50%;
//           animation: spinner-border 0.75s linear infinite;
//         }
//         @keyframes spinner-border {
//           to { transform: rotate(360deg); }
//         }
//         .visually-hidden {
//           position: absolute;
//           width: 1px;
//           height: 1px;
//           padding: 0;
//           margin: -1px;
//           overflow: hidden;
//           clip: rect(0, 0, 0, 0);
//           border: 0;
//         }

//         .manager-progress-container {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .manager-percent {
//           font-size: 12px;
//           font-weight: 600;
//           min-width: 40px;
//           color: #374151;
//         }
//         .manager-progress-bar {
//           flex: 1;
//           height: 6px;
//           background: #E5E7EB;
//           border-radius: 3px;
//           overflow: hidden;
//           min-width: 50px;
//         }
//         .manager-progress-fill {
//           height: 100%;
//           border-radius: 3px;
//           transition: width 0.5s ease;
//         }

//         .manager-source-badge {
//           display: inline-block;
//           padding: 2px 10px;
//           border-radius: 12px;
//           font-size: 11px;
//           font-weight: 500;
//         }
//         .manager-badge-website { background: #DBEAFE; color: #1E40AF; }
//         .manager-badge-whatsapp { background: #D1FAE5; color: #065F46; }
//         .manager-badge-app { background: #E0E7FF; color: #3730A3; }
//         .manager-badge-walk_in { background: #FEF3C7; color: #92400E; }
//         .manager-badge-referred { background: #FCE7F3; color: #BE185D; }
//         .manager-badge-admin { background: #F3F4F6; color: #4B5563; }

//         .manager-member-name { font-weight: 600; color: #111827; }
//         .manager-won-value { color: #059669; font-weight: 600; }
//         .manager-stat-team .manager-top-stat-value { color: #8B5CF6; }
//         .manager-stat-money .manager-top-stat-value { color: #10B981; }
//       `}</style>
//     </div>
//   );
// };

// const loadingStyle = {
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   justifyContent: 'center',
//   padding: '60px 20px',
//   gap: '16px',
//   color: '#6B7280',
//   fontSize: '14px',
// };

// export default ManagerDashboard;



import React, { useState, useEffect } from 'react';
import './ManagerDashboard.css';
import { getAllEnquiries } from '../../../Servicefile/salesService';

const ManagerDashboard = ({ switchTab }) => {
  // ─── State ──────────────────────────────────────────────────────
  const [loading, setLoading] = useState(true);
  const [enquiries, setEnquiries] = useState([]);
  const [teamPerformance, setTeamPerformance] = useState([]);
  const [totalPayments, setTotalPayments] = useState(0);

  // ─── Stats Data ──────────────────────────────────────────────────
  const [stats, setStats] = useState({
    totalEnquiries: 0,
    totalBudget: 0,
    enquiry: { count: 0, budget: 0 },
    approval: { count: 0, budget: 0 },
    quote: { count: 0, budget: 0 },
    assigned: { count: 0, budget: 0 },
    completed: { count: 0, budget: 0 },
    rejected: { count: 0, budget: 0 },
    teamMembers: 0,
    totalLeadsMoney: 0,
  });

  // ─── Pipeline Stages Data ──────────────────────────────────────
  const [pipelineData, setPipelineData] = useState({
    stages: ['Enquiry', 'Approval', 'Quote', 'Assigned', 'Completed', 'Rejected'],
    counts: [0, 0, 0, 0, 0, 0],
    values: ['₹0', '₹0', '₹0', '₹0', '₹0', '₹0']
  });

  // ─── Enquiry Status Cards ──────────────────────────────────────
  const [enquiryStatusCards, setEnquiryStatusCards] = useState([
    { name: 'Enquiry', count: 0, value: '₹0', color: 'pending' },
    { name: 'Approved', count: 0, value: '₹0', color: 'approved' },
    { name: 'Quoted', count: 0, value: '₹0', color: 'submitted' },
    { name: 'Assigned', count: 0, value: '₹0', color: 'assigned' },
    { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
  ]);

  // ─── Project Status Cards ──────────────────────────────────────
  const [projectStatusCards, setProjectStatusCards] = useState([
    { name: 'Initiated', count: 0, value: '₹0', color: 'initiated' },
    { name: 'In Progress', count: 0, value: '₹0', color: 'progress' },
    { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
  ]);

  // ─── Recent Enquiries ──────────────────────────────────────────
  const [recentEnquiries, setRecentEnquiries] = useState([]);

  // ─── Format Currency ──────────────────────────────────────────
  const formatCurrency = (amount) => {
    if (!amount) return '₹0';
    return `₹${Number(amount).toLocaleString('en-IN')}`;
  };

  // ─── Fetch Enquiries Data ─────────────────────────────────────
  const fetchEnquiriesData = async () => {
    try {
      const data = await getAllEnquiries();
      setEnquiries(data || []);
      return data || [];
    } catch (error) {
      console.error('Error fetching enquiries:', error);
      return [];
    }
  };

  // ─── Fetch Team Performance ──────────────────────────────────
  const fetchTeamPerformance = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch("https://backend.maamaas.com/catering/api/admin/team-performance", {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch team performance: ${response.status}`);
      }

      const data = await response.json();
      const teamData = Array.isArray(data) ? data : [];
      setTeamPerformance(teamData);
      return teamData;

    } catch (error) {
      console.error('Error fetching team performance:', error);
      return [];
    }
  };

  // ─── Fetch Payments Data ─────────────────────────────────────
  const fetchPaymentsData = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch("https://backend.maamaas.com/catering/api/admin/payments", {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch payments: ${response.status}`);
      }

      const data = await response.json();
      const total = data?.data?.reduce((sum, payment) => sum + (payment.paymentAmount || 0), 0) || 0;
      setTotalPayments(total);
      return total;

    } catch (error) {
      console.error('Error fetching payments:', error);
      return 0;
    }
  };

  // ─── Calculate Stats ─────────────────────────────────────────
  const calculateStats = (data, teamData, paymentsTotal) => {
    const getStatusStats = (status) => {
      const items = data.filter(e => e.leadStatus === status);
      const count = items.length;
      const budget = items.reduce((sum, e) => sum + (e.budget || 0), 0);
      return { count, budget };
    };

    const enquiry = getStatusStats('PENDING');
    const approval = getStatusStats('APPROVED');
    const quote = getStatusStats('PAYMENT_RECEIVED');
    const assigned = getStatusStats('ASSIGNED');
    const completed = getStatusStats('CLOSED');
    const rejected = getStatusStats('REJECTED');

    const totalEnquiries = data.length;
    const totalBudget = data.reduce((sum, e) => sum + (e.budget || 0), 0);

    const uniqueMembers = new Set(teamData.map(item => item.executiveName));
    const teamMembers = uniqueMembers.size;

    setStats({
      totalEnquiries,
      totalBudget,
      enquiry,
      approval,
      quote,
      assigned,
      completed,
      rejected,
      teamMembers,
      totalLeadsMoney: paymentsTotal,
    });

    setPipelineData({
      stages: ['Enquiry', 'Approval', 'Quote', 'Assigned', 'Completed', 'Rejected'],
      counts: [
        enquiry.count,
        approval.count,
        quote.count,
        assigned.count,
        completed.count,
        rejected.count
      ],
      values: [
        formatCurrency(enquiry.budget),
        formatCurrency(approval.budget),
        formatCurrency(quote.budget),
        formatCurrency(assigned.budget),
        formatCurrency(completed.budget),
        formatCurrency(rejected.budget)
      ]
    });

    setEnquiryStatusCards([
      { name: 'Enquiry', count: enquiry.count, value: formatCurrency(enquiry.budget), color: 'pending' },
      { name: 'Approved', count: approval.count, value: formatCurrency(approval.budget), color: 'approved' },
      { name: 'Quoted', count: quote.count, value: formatCurrency(quote.budget), color: 'submitted' },
      { name: 'Assigned', count: assigned.count, value: formatCurrency(assigned.budget), color: 'assigned' },
      { name: 'Completed', count: completed.count, value: formatCurrency(completed.budget), color: 'completed' },
    ]);

    const initiated = data.filter(e => e.leadStatus === 'ASSIGNED' || e.leadStatus === 'ACCEPT');
    const inProgress = data.filter(e => e.leadStatus === 'APPROVED' || e.leadStatus === 'PAYMENT_RECEIVED');
    const completedProjects = data.filter(e => e.leadStatus === 'CLOSED');

    setProjectStatusCards([
      {
        name: 'Initiated',
        count: initiated.length,
        value: formatCurrency(initiated.reduce((sum, e) => sum + (e.budget || 0), 0)),
        color: 'initiated'
      },
      {
        name: 'In Progress',
        count: inProgress.length,
        value: formatCurrency(inProgress.reduce((sum, e) => sum + (e.budget || 0), 0)),
        color: 'progress'
      },
      {
        name: 'Completed',
        count: completedProjects.length,
        value: formatCurrency(completedProjects.reduce((sum, e) => sum + (e.budget || 0), 0)),
        color: 'completed'
      },
    ]);

    const recentData = data
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 4)
      .map(e => ({
        id: e.enquiryId || e.id || 'N/A',
        client: e.companyName || e.fullName || 'Unknown',
        quote: formatCurrency(e.budget || 0),
        status: e.leadStatus === 'PENDING' ? 'Pending' :
          e.leadStatus === 'APPROVED' ? 'Approved' :
            e.leadStatus === 'PAYMENT_RECEIVED' ? 'Quote Submitted' :
              e.leadStatus === 'ASSIGNED' ? 'Assigned' :
                e.leadStatus === 'CLOSED' ? 'Completed' : 'Rejected',
        clientStatus: e.leadStatus === 'APPROVED' ? 'Accepted' :
          e.leadStatus === 'PAYMENT_RECEIVED' ? 'Under Review' :
            e.leadStatus === 'ASSIGNED' ? 'In Progress' :
              e.leadStatus === 'CLOSED' ? 'Delivered' : '—',
        owner: e.sourceBy || 'N/A'
      }));

    setRecentEnquiries(recentData);
  };

  // ─── Fetch All Data ──────────────────────────────────────────
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const [enquiriesData, teamData, paymentsTotal] = await Promise.all([
        fetchEnquiriesData(),
        fetchTeamPerformance(),
        fetchPaymentsData()
      ]);

      calculateStats(enquiriesData, teamData, paymentsTotal);

    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  // ─── Handle View All - Now switches to Enquiries tab ──────────
  const handleViewAll = () => {
    // Dispatch event to switch to Enquiries tab
    const event = new CustomEvent('changeTab', { detail: { tabId: 'enquiries' } });
    window.dispatchEvent(event);
  };

  // ─── Render ───────────────────────────────────────────────────
  if (loading) {
    return (
      <div style={loadingStyle}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading dashboard data...</p>
      </div>
    );
  }

  return (
    <div className="manager-dashboard-container">
      <div className="manager-dashboard-wrapper">
        {/* Top Stats Grid - 10 Cards */}
        <div className="manager-top-stats-grid">
          <div className="manager-top-stat-card manager-stat-total">
            <div className="manager-top-stat-label">TOTAL LEADS</div>
            <div className="manager-top-stat-value">{stats.totalEnquiries}</div>
            <div className="manager-top-stat-sub">Total count</div>
          </div>

          <div className="manager-top-stat-card">
            <div className="manager-top-stat-label">ENQUIRY</div>
            <div className="manager-top-stat-value">{stats.enquiry.count}</div>
            <div className="manager-top-stat-sub">{formatCurrency(stats.enquiry.budget)}</div>
          </div>

          <div className="manager-top-stat-card">
            <div className="manager-top-stat-label">APPROVAL</div>
            <div className="manager-top-stat-value">{stats.approval.count}</div>
            <div className="manager-top-stat-sub">{formatCurrency(stats.approval.budget)}</div>
          </div>

          <div className="manager-top-stat-card">
            <div className="manager-top-stat-label">QUOTE</div>
            <div className="manager-top-stat-value">{stats.quote.count}</div>
            <div className="manager-top-stat-sub">{formatCurrency(stats.quote.budget)}</div>
          </div>

          <div className="manager-top-stat-card">
            <div className="manager-top-stat-label">ASSIGNED</div>
            <div className="manager-top-stat-value">{stats.assigned.count}</div>
            <div className="manager-top-stat-sub">{formatCurrency(stats.assigned.budget)}</div>
          </div>

          <div className="manager-top-stat-card">
            <div className="manager-top-stat-label">COMPLETED</div>
            <div className="manager-top-stat-value">{stats.completed.count}</div>
            <div className="manager-top-stat-sub">{formatCurrency(stats.completed.budget)}</div>
          </div>

          <div className="manager-top-stat-card">
            <div className="manager-top-stat-label">REJECTED</div>
            <div className="manager-top-stat-value">{stats.rejected.count}</div>
            <div className="manager-top-stat-sub">{formatCurrency(stats.rejected.budget)}</div>
          </div>

          <div className="manager-top-stat-card manager-stat-total">
            <div className="manager-top-stat-label">TOTAL BUDGET</div>
            <div className="manager-top-stat-value">{formatCurrency(stats.totalBudget)}</div>
            <div className="manager-top-stat-sub">All enquiries</div>
          </div>

          <div className="manager-top-stat-card manager-stat-team">
            <div className="manager-top-stat-label">TEAM MEMBERS</div>
            <div className="manager-top-stat-value">{stats.teamMembers}</div>
            <div className="manager-top-stat-sub">Active sellers</div>
          </div>

          <div className="manager-top-stat-card manager-stat-money">
            <div className="manager-top-stat-label">TOTAL LEADS MONEY</div>
            <div className="manager-top-stat-value">{formatCurrency(stats.totalLeadsMoney)}</div>
            <div className="manager-top-stat-sub">From all leads</div>
          </div>
        </div>

        {/* Pipeline Flow Section */}
        <div className="manager-pipeline-area">
          <h2 className="manager-section-heading">Pipeline Flow</h2>
          <div className="manager-pipeline-track">
            {pipelineData.stages.map((stage, idx) => (
              <React.Fragment key={idx}>
                <div className="manager-pipeline-node">
                  <div className="manager-pipeline-name">{stage}</div>
                  <div className="manager-pipeline-counter">{pipelineData.counts[idx]}</div>
                  <div className="manager-pipeline-amount">{pipelineData.values[idx]}</div>
                </div>
                {idx < pipelineData.stages.length - 1 && (
                  <div className="manager-pipeline-connector">→</div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Two Column Layout */}
        <div className="manager-two-column-layout">
          <div className="manager-enquiry-status-area">
            <h2 className="manager-section-heading">Enquiry status</h2>
            <div className="manager-status-cards-grid">
              {enquiryStatusCards.map((card, idx) => (
                <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
                  <div className="manager-status-card-name">{card.name}</div>
                  <div className="manager-status-card-count">{card.count}</div>
                  <div className="manager-status-card-value">{card.value}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="manager-project-status-area">
            <h2 className="manager-section-heading">Project status</h2>
            <div className="manager-status-cards-grid">
              {projectStatusCards.map((card, idx) => (
                <div key={idx} className={`manager-status-card manager-status-card-${card.color}`}>
                  <div className="manager-status-card-name">{card.name}</div>
                  <div className="manager-status-card-count">{card.count}</div>
                  <div className="manager-status-card-value">{card.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team Performance Table */}
        {teamPerformance.length > 0 && (
          <div className="manager-recent-area">
            <div className="manager-recent-header">
              <h2 className="manager-section-heading">Team Performance & Targets</h2>
              {/* <a href="#" className="manager-view-all-link">Download Report →</a> */}
            </div>
            <div className="manager-table-wrapper">
              <table className="manager-data-table">
                <thead>
                  <tr className="manager-table-header-row">
                    <th className="manager-table-header">EXECUTIVE</th>
                    <th className="manager-table-header">SOURCE</th>
                    <th className="manager-table-header">ROLE</th>
                    <th className="manager-table-header">ENQUIRIES</th>
                    <th className="manager-table-header">WON</th>
                    <th className="manager-table-header">VALUE</th>
                    <th className="manager-table-header">TARGET</th>
                  </tr>
                </thead>
                <tbody>
                  {teamPerformance.map((member, idx) => (
                    <tr key={idx} className="manager-table-row">
                      <td className="manager-table-cell manager-member-name">{member.executiveName || '-'}</td>
                      <td className="manager-table-cell">
                        <span className={`manager-source-badge manager-badge-${member.source?.toLowerCase()}`}>
                          {member.source || '-'}
                        </span>
                      </td>
                      <td className="manager-table-cell">{member.role || '-'}</td>
                      <td className="manager-table-cell">{member.enquiries || 0}</td>
                      <td className="manager-table-cell manager-won-value">{member.won || 0}</td>
                      <td className="manager-table-cell">{formatCurrency(member.value || 0)}</td>
                      <td className="manager-table-cell">
                        <div className="manager-progress-container">
                          <span className="manager-percent">{member.target || 0}%</span>
                          <div className="manager-progress-bar">
                            <div
                              className="manager-progress-fill"
                              style={{
                                width: `${Math.min(member.target || 0, 100)}%`,
                                background: member.target >= 80 ? '#10B981' : member.target >= 50 ? '#F59E0B' : '#EF4444'
                              }}
                            ></div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Recent Enquiries Section */}
        <div className="manager-recent-area">
          <div className="manager-recent-header">
            <h2 className="manager-section-heading">Recent enquiries</h2>
            <a
              href="#"
              className="manager-view-all-link"
              onClick={(e) => {
                e.preventDefault();
                handleViewAll(); // Now switches to Enquiries tab
              }}
            >
              View all →
            </a>
          </div>

          <div className="manager-table-wrapper">
            <table className="manager-data-table">
              <thead>
                <tr className="manager-table-header-row">
                  <th className="manager-table-header">ID</th>
                  <th className="manager-table-header">CLIENT</th>
                  <th className="manager-table-header">QUOTE</th>
                  <th className="manager-table-header">STATUS</th>
                  <th className="manager-table-header">CLIENT STATUS</th>
                  <th className="manager-table-header">OWNER</th>
                </tr>
              </thead>
              <tbody>
                {recentEnquiries.length > 0 ? (
                  recentEnquiries.map((row, idx) => (
                    <tr key={idx} className="manager-table-row">
                      <td className="manager-table-cell">{row.id}</td>
                      <td className="manager-table-cell">{row.client}</td>
                      <td className="manager-table-cell">{row.quote}</td>
                      <td className="manager-table-cell">
                        <span className={`manager-status-badge manager-badge-${row.status.toLowerCase().replace(/\s+/g, '-')}`}>
                          {row.status}
                        </span>
                      </td>
                      <td className="manager-table-cell">
                        {row.clientStatus !== '—' ? (
                          <span className={`manager-client-badge manager-client-${row.clientStatus.toLowerCase()}`}>
                            {row.clientStatus}
                          </span>
                        ) : (
                          <span className="manager-client-badge manager-client-empty">—</span>
                        )}
                      </td>
                      <td className="manager-table-cell">{row.owner}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#9CA3AF' }}>
                      No recent enquiries
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style>{`
        .spinner-border {
          display: inline-block;
          width: 2rem;
          height: 2rem;
          border: 0.25em solid currentColor;
          border-right-color: transparent;
          border-radius: 50%;
          animation: spinner-border 0.75s linear infinite;
        }
        @keyframes spinner-border {
          to { transform: rotate(360deg); }
        }
        .visually-hidden {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          border: 0;
        }

        .manager-progress-container {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .manager-percent {
          font-size: 12px;
          font-weight: 600;
          min-width: 40px;
          color: #374151;
        }
        .manager-progress-bar {
          flex: 1;
          height: 6px;
          background: #E5E7EB;
          border-radius: 3px;
          overflow: hidden;
          min-width: 50px;
        }
        .manager-progress-fill {
          height: 100%;
          border-radius: 3px;
          transition: width 0.5s ease;
        }

        .manager-source-badge {
          display: inline-block;
          padding: 2px 10px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 500;
        }
        .manager-badge-website { background: #DBEAFE; color: #1E40AF; }
        .manager-badge-whatsapp { background: #D1FAE5; color: #065F46; }
        .manager-badge-app { background: #E0E7FF; color: #3730A3; }
        .manager-badge-walk_in { background: #FEF3C7; color: #92400E; }
        .manager-badge-referred { background: #FCE7F3; color: #BE185D; }
        .manager-badge-admin { background: #F3F4F6; color: #4B5563; }

        .manager-member-name { font-weight: 600; color: #111827; }
        .manager-won-value { color: #059669; font-weight: 600; }
        .manager-stat-team .manager-top-stat-value { color: #8B5CF6; }
        .manager-stat-money .manager-top-stat-value { color: #10B981; }
        .progress {
          width: 40%;
          height: 100%;
          animation: none;
          background: rgba(255, 255, 255, 0.2);
        }
      `}
      </style>
    </div>
  );
};

const loadingStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '60px 20px',
  gap: '16px',
  color: '#6B7280',
  fontSize: '14px',
};

export default ManagerDashboard;